import { render, staticRenderFns } from "./debit-note.vue?vue&type=template&id=640c73c5"
import script from "./debit-note.vue?vue&type=script&lang=js"
export * from "./debit-note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports